import React from 'react';
import Modal from '@mui/material/Modal';
import "./saleReturnApprovalModal.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
const SaleReturnApprovalModal = (props: { open: boolean, closeModal: ()=>void, onClick:()=>any}) => {
    return (
        <Modal
            open={props.open}
            onClose={props.closeModal}
            aria-labelledby="sale-return-approval-modal-title"
            aria-describedby="sale-return-approval-modal-description"
        >
            <div className='sale-return-approval-container'>
                            <div className='sale-return-approval-header'>
                                <FontAwesomeIcon
                                    icon={faXmark}
                                    onClick={props.closeModal}
                                />
                            </div>
                            <div className='sale-return-approval-body'>
                                <div></div>
                                <div className='sale-return-approval-title'>
                                    Return Qty has been approved successfully
                                </div>
                                <button
                                        className={`view-sale-return-submit`}
                                        onClick={()=>{props.onClick()}}
                                    >
                                        <span className="view-sale-return-submit-text">
                                            Issue Credit Note
                                        </span>
                                    </button>
                            </div>
                        </div>
        </Modal>
    );
};

export default SaleReturnApprovalModal;
